import {getExtraSetting, saveExtraSetting} from '../../../_metronic/helpers'

/**
 * The announcements of «امکانات تازه» this user has seen, kept with the user's settings
 * (api/auth/user/extrasetting) so the header's icon stops shaking on every device once the list was
 * opened.
 */
export const WHATS_NEW_SEEN_SETTING = 'whatsNewSeen'

export const readSeenAnnouncements = (setting: unknown): string[] => {
  const seen = (setting as {seen?: unknown} | null | undefined)?.seen
  return Array.isArray(seen) ? seen.filter((id): id is string => typeof id === 'string') : []
}

/** The announced ids not seen yet; none while the seen list is unknown (not read, or the read failed). */
export const unseenAnnouncements = (announced: string[], seen: string[] | undefined): string[] =>
  seen === undefined ? [] : announced.filter((id) => !seen.includes(id))

export const loadSeenAnnouncements = async (): Promise<string[]> =>
  readSeenAnnouncements(await getExtraSetting(WHATS_NEW_SEEN_SETTING))

/** Answers with the session's renewed token, as every user setting does. */
export const saveSeenAnnouncements = (seen: string[]) =>
  saveExtraSetting(WHATS_NEW_SEEN_SETTING, {seen, at: new Date().toISOString()})
